import React, { useState } from "react";
import { BsArrowLeft, BsPersonFillLock } from "react-icons/bs";
import { RiLockPasswordLine } from "react-icons/ri";
import { SlArrowRight } from "react-icons/sl";
import ClipLoader from "react-spinners/ClipLoader";
import { useUser } from "../../../context/user-context";
import { useAuth } from "../../../context/auth-context";
import useAuthAxios from "../../../utils/baseAxios";
import { API } from "../../../constants/api";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { errorMessage } from "../../../utils/errorMessage";
import GoogleAuth from "./GoogleAuth";
import ChangePassword from "./ChangePassword";
import ChangeTxnPin from "./ChangeTxnPin";
import { IoUnlinkSharp } from "react-icons/io5";
import LinkedAccount from "./LinkedAccount";

const Security = ({ setOpenSecurity, setOpenAddPhone }: any) => {
  const { userDetails, refetch } = useUser();
  const { logout } = useAuth();
  const [openGAuth, setOpenGAuth] = useState<boolean>(false);
  const [openPassword, setOpenPassword] = useState<boolean>(false);
  const [openPin, setOpenPin] = useState<boolean>(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();
  const [openLinkedAccount, setOpenLinkedAccount] = useState<boolean>(false);
  const email2fa = userDetails?.user?.account?.settings["2fa"].active;
  const google2fa = userDetails?.user?.account?.settings["2fa-auth-app"].active;
  const emailActive = !email2fa;
  const toggleEmail2fa = async () => {
    const response = await axiosInstance.post(API.toggle2Fa(emailActive), {});
    return response.data;
  };
  const completeToggleMail = useMutation({
    mutationFn: toggleEmail2fa,
    onSuccess: (r) => {
      // console.log(r);
      toast.success(r.message);
      // queryClient.invalidateQueries({
      //   queryKey: ["user-preferences"],
      // });
      refetch();
    },
    onError: (e) => {
      console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  const toggleGoogle2fa = async () => {
    const response = await axiosInstance.post(API.deactivateGoogleAuth, {});
    return response.data;
  };
  const completeToggleGoogle = useMutation({
    mutationFn: toggleGoogle2fa,
    onSuccess: (r) => {
      // console.log(r);
      toast.success(r.message);
      // queryClient.invalidateQueries({
      //   queryKey: ["user-preferences"],
      // });
      refetch();
    },
    onError: (e) => {
      console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const deleteAccount = async () => {
    const response = await axiosInstance.delete(API.deleteAccount);
    return response.data;
  };
  const deleteAccountMutation = useMutation({
    mutationFn: deleteAccount,
    onSuccess: (r) => {
      toast.success(r?.message ?? "Your account has been deleted.");
      setOpenDeleteConfirm(false);
      setOpenSecurity(false);
      logout();
    },
    onError: (e) => {
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenSecurity(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Security settings
          </h4>
        </div>
        <div className="w-full mt-6">
          <div className="w-full">
            <h4 className="text-gray-800 dark:text-gray-200 text-[15px] font-medium">
              Select action
            </h4>
            <div
              onClick={() => setOpenPin(true)}
              className="flex justify-between py-4 mt-4 border rounded-xl px-3 border-gray-200 dark:border-gray-600  items-center cursor-pointer"
            >
              <div className="flex justify-start items-center gap-4">
                <div className="flex justify-center items-center text-[28px] text-secondary_button w-[32px] h-[32px] rounded-full">
                  <BsPersonFillLock />
                </div>
                <div>
                  <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px] ">
                    Change transaction pin
                  </h4>
                </div>
              </div>
              <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[15px]" />
            </div>
            <div
              onClick={() => setOpenPassword(true)}
              className="flex justify-between py-4 mt-4 border rounded-xl px-3 border-gray-200 dark:border-gray-600  items-center cursor-pointer"
            >
              <div className="flex justify-start items-center gap-4">
                <div className="flex justify-center items-center text-[28px] text-secondary_button w-[32px] h-[32px] rounded-full">
                  <RiLockPasswordLine />
                </div>
                <div>
                  <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px] ">
                    Change Password
                  </h4>
                </div>
              </div>
              <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[15px]" />
            </div>
            <div
              onClick={() => setOpenLinkedAccount(true)}
              className="flex justify-between py-4 mt-4 border rounded-xl px-3 border-gray-200 dark:border-gray-600  items-center cursor-pointer"
            >
              <div className="flex justify-start items-center gap-4">
                <div className="flex justify-center items-center text-[28px] text-secondary_button w-[32px] h-[32px] rounded-full">
                  <IoUnlinkSharp />
                </div>
                <div>
                  <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px] ">
                    Linked Account
                  </h4>
                </div>
              </div>
              <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[15px]" />
            </div>
          </div>
          <div className="w-full mt-8">
            <h4 className="text-gray-800 dark:text-gray-200 text-[15px] font-medium">
              Preferences
            </h4>
            <div className="flex justify-between py-4 mt-4 border rounded-xl px-3 gap-6 border-gray-200 dark:border-gray-600  items-center ">
              <div className="flex flex-col justify-start items-center gap-4">
                <div>
                  <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px] ">
                    2FA
                  </h4>
                  <h4 className="text-gray-500 mt-1  text-[13px] ">
                    We will be sending you a 6-digits code when you login or
                    make some changes to settings
                  </h4>
                </div>
                <div className="w-full flex justify-between mt-4   gap-4   items-center ">
                  <div className="flex justify-start items-center ">
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px] ">
                        Email
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Send a One time password (OTP) to your email.
                      </h4>
                    </div>
                  </div>
                  <div className="flex justify-center gap-2 lgss:gap-4 mx-4 lgss:mx-0 items-center flex-col lgss:flex-row">
                    <div
                      onClick={() => {
                        completeToggleMail.mutate();
                      }}
                      className={`flex w-[52px] cursor-pointer h-8  rounded-full transition-all duration-500 ${
                        email2fa ? "bg-secondary_button" : "bg-gray-600"
                      }`}
                    >
                      <span
                        className={`h-8  w-8 rounded-full transition-all duration-500 bg-gray-100 ${
                          email2fa ? "ml-5" : ""
                        }`}
                      ></span>
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-between mt-4   gap-4   items-center ">
                  <div className="flex justify-start items-center ">
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-100 font-medium text-[15px] ">
                        Google Authentication
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Send a One time password (OTP) to your google
                        authenticator app.
                      </h4>
                    </div>
                  </div>
                  <div className="flex justify-center gap-2 lgss:gap-4 mx-4 lgss:mx-0 items-center flex-col lgss:flex-row">
                    <div
                      onClick={() => {
                        if (google2fa) {
                          completeToggleGoogle.mutate();
                        } else {
                          setOpenGAuth(true);
                        }
                      }}
                      className={`flex w-[52px] cursor-pointer h-8  rounded-full transition-all duration-500 ${
                        google2fa ? "bg-secondary_button" : "bg-gray-600"
                      }`}
                    >
                      <span
                        className={`h-8  w-8 rounded-full transition-all duration-500 bg-gray-100 ${
                          google2fa ? "ml-5" : ""
                        }`}
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" w-full mt-8">
              <button
                type="button"
                onClick={() => setOpenDeleteConfirm(true)}
                className="py-3 w-full rounded-xl bg-[#D92B2B] text-white font-medium text-[15px]"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {openGAuth && <GoogleAuth setOpenGAuth={setOpenGAuth} />}
      {openPassword && <ChangePassword setOpenPassword={setOpenPassword} />}
      {openPin && <ChangeTxnPin setOpenPin={setOpenPin} />}
      {openLinkedAccount && (
        <LinkedAccount
          setOpenLinkedAccount={setOpenLinkedAccount}
          setOpenAddPhone={setOpenAddPhone}
          setOpenSecurity={setOpenSecurity}
        />
      )}
      {openDeleteConfirm && (
        <div
          className="fixed inset-0 z-[100] flex font-manrope justify-center items-center px-4 bg-black/40 dark:bg-black/60 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-labelledby="delete-account-title"
        >
          <div className="w-full max-w-md border dark:border-[#303030] bg-white dark:bg-[#192025] rounded-xl p-6 shadow-lg">
            <h4
              id="delete-account-title"
              className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[18px]"
            >
              Delete account?
            </h4>
            <p className="mt-3 text-gray-600 dark:text-gray-400 text-[14px] leading-relaxed">
              This will permanently remove your account and associated data.
              You cannot undo this action. Are you sure you want to continue?
            </p>
            <div className="mt-6 flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
              <button
                type="button"
                disabled={deleteAccountMutation.isPending}
                onClick={() => setOpenDeleteConfirm(false)}
                className="py-3 sm:py-2.5 px-4 rounded-xl border border-gray-200 dark:border-gray-600 text-gray-800 dark:text-gray-200 font-medium text-[15px] disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={deleteAccountMutation.isPending}
                onClick={() => deleteAccountMutation.mutate()}
                className="py-3 sm:py-2.5 px-4 rounded-xl bg-[#D92B2B] text-white font-medium text-[15px] flex items-center justify-center gap-2 min-w-[120px] disabled:opacity-70"
              >
                {deleteAccountMutation.isPending ? (
                  <ClipLoader color="#ffffff" size={20} />
                ) : (
                  "Yes, delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Security;
